<template>
    <div>
      <div v-if="show">
        <v-row class="justify-center">
          <v-col cols="12" md="8">
            <v-row class="mt-4 mx-4">
              <v-icon color="primary">mdi-calculator</v-icon>
              <h3 class="primary--text">Orçamento de Álbum</h3>
              <v-spacer></v-spacer>
              <span class="primary--text mr-4">{{ hoje }}</span>
            </v-row>
  
            <v-row class="align-center">
              <v-col cols="12" sm="6">
                <div style="height: 220px; align-content: center">
                  <v-row class="justify-center ml-4">
                    <img
                      style="width: 192px; height:192px;"
                      :src="img_produto"
                    />
                  </v-row>
                  <v-row class="justify-center ml-4 primary--text">
                    <strong v-if="tipo === 'Álbum Premium'">Lâminas de gramatura 800</strong>
                    <strong v-if="tipo === 'Álbum Slim'">Lâminas de gramatura 250</strong>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div style="height: 200px; align-content: center">
                  <v-row class="mx-8">
                    <v-select
                      :items="produtos.tipos"
                      v-model="tipo"
                      item-text="text"
                      item-value="id"
                      label="Tipo"
                      @change="
                        setImagem(tipo);
                        limpar();
                        setTamanhoLamina();
                      "
                    ></v-select>
                  </v-row>
                  <div v-if="tipo === 'Álbum Premium'" class="my-1">
                    <v-row class="mx-8 my-2 align-center">
                      <v-select
                        :hint="hint"
                        persistent-hint
                        :items="produtos.capa"
                        v-model="capa"
                        item-text="text"
                        item-value="id"
                        :label="labelCapa"
                        @change="
                          setImagem(capa);
                          setCapa(capa)
                          valor = '';
                          disabled = true;
                        "
                      ></v-select>
                    </v-row>
                  </div>
                  <v-row class="mx-8 my-2">
                    <v-select
                      color="primary"
                      :items="tamanhos"
                      v-model="tamanho"
                      item-text="text"
                      item-value="id"
                      label="Tamanho"
                      @change="valor = ''; disabled = true; tamanhoSelected(tamanho);"
                    ></v-select>
                  </v-row>
                </div>
              </v-col>
            </v-row>
  
            <v-row class="mx-4 align-center mt-0 pt-0">
              <v-col cols="6">
                <v-select
                  :items="items_lam"
                  v-model="laminas"
                  item-text="text"
                  label="Lâminas"
                  @change="
                    valor = '';
                    disabled = true;
                    setPaginas();
                  "
                ></v-select>
              </v-col>
              <!-- :readonly="laminas ? false : true" -->
               <!-- @click="setPaginas()" -->
              <v-col cols="6">
                  <v-text-field
                    type="number"
                    color="success"
                    v-model="extras"
                    max="10"
                    min="0"
                    :label="labelExtra"
                    @click="setPaginas()"
                    @change="valor = ''; somaExtra(); disabled = true;"
                  ></v-text-field>
              </v-col>
            </v-row>
            
            <v-row class="mx-4 align-center mt-0 pt-0">
              <v-col cols="6">
                <v-row class="justify-center">
                  Total:<strong class="mx-3">{{ paginas }}</strong
                  ><span>{{ "páginas" }}</span>
                  </v-row>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="produtos.laminacao"
                  v-model="laminacao"
                  item-text="text"
                  item-value="id"
                  label="Laminação"
                  @change="valor = ''; disabled = true;"
                ></v-select>
              </v-col>
            </v-row>

            <div v-if="tipo === 'Álbum Premium'">
              <v-row class="justify-center my-2">
                <strong>Acessórios</strong>
              </v-row>
              <v-row class="mx-2 justify-center">
                <!-- <v-col cols="12"> -->
                  <v-card
                    width="300"
                    class="pa-0 ma-1 secondary"
                    outlined
                    tile
                    v-for="number in produtos.acessorios.length"
                    :key="number"
                  >
                  <v-card-text>
                    <v-row class="align-center">
                      <v-img
                        :src="setImgAcessorio(produtos.acessorios[number - 1])"
                        max-width="64"
                        max-height="64"
                      ></v-img>
                      <div class="ml-6">
                      <v-row>
                        <v-checkbox
                          hide-details
                          :label="produtos.acessorios[number - 1]"
                          v-model="item[number - 1]"
                          @change="valor = ''; disabled = true;"
                        ></v-checkbox>
                      </v-row>
                      <v-row>
                        <span class="primary--text">{{ precoItems[number - 1] || "------" }}</span>
                      </v-row>
                    </div>
                    </v-row>
                  </v-card-text>
                </v-card>
                <!-- </v-col> -->
              </v-row>
            </div>

            <v-col cols="12">
              <v-row class="align-center ma-4 px-2">
                <v-col cols="12" sm="6">
                  <v-textarea
                    class="pa-2"
                    background-color="secondary"
                    color="primary"
                    label="Demanda Especial"
                    v-model="obs"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-row class="text-justify">
                    <span style="font-size: 10pt;" class="primary--text">Caso tenha necessidade de algum produto ou serviço que não esteja listado aqui, anote ao lado sua demanda e salve ou entre em contato pelo nosso WhatsApp. Nosso representante responderá em breve.</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
  
            <v-row class="mr-8 my-4 py-4 align-center ml-8">
              <v-btn :disabled="disabled" outlined rounded color="accent" @click="salvarCalc()"
                >salvar orçamento</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn outlined rounded class="secondary primary--text" @click="btnLimpar()"
                >limpar</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn outlined rounded color="primary" @click="calcular()"
                >calcular</v-btn
              >
              <v-spacer></v-spacer>
   
                <v-text-field
                  type="number"
                  color="success"
                  v-model="valor"
                  label="Valor"
                  readonly
                ></v-text-field>
  
            </v-row>
          </v-col>
        </v-row>
      </div>
  
      <div v-else>
        <v-row style="height: 80vh" class="justify-center align-center">
          <v-progress-circular
            :size="60"
            :width="8"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-row>
      </div>
  
      <mostruario />
  
      <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
          {{ msg }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="alert = false">
              X
            </v-btn>
          </template>
        </v-snackbar>
  
    </div>
  </template>
  
  <script>
  // import IMG from "../assets/sem_img.jpg";
  import mostruario from "../components/Mostruario.vue"
  
  export default {
    name: "ordem-servico",
    components: {
      mostruario
    },
    computed: {
      logado() {
        return this.$store.getters.logado;
      },
      user() {
        return this.$store.getters.user;
      },
      produtos() {
        return this.$store.getters.produtos;
      },
      precos() {
        return this.$store.getters.precosCm2;
      },
      imagens() {
        return this.$store.getters.imagens;
      },
      autorizados() {
        return this.$store.getters.autorizados;
      },
      verificaAdmin() {
        return this.$store.getters.verificaAdmin;
      },
      mostruario() {
        return this.$store.getters.mostruario;
      },
      sem_img() {
        return this.$store.getters.sem_img;
      }
    },
    watch: {
      logado(l) {
        console.log(!!l)
      },
      autorizados(a) {
        this.$store.dispatch("setVerificaAdmin", {
          uid: this.user.uid,
          admins: a,
        });
      },
      mostruario (m) {
        if (!m && this.tipo === "Álbum Premium") {
          this.capa = ""
          this.hint = ""
          // this.showAlert("Escolha a capa novamente.")
        } 
        if (m && this.tipo === "Álbum Premium" &&
          this.capa === "Capa tecido ou sintético" ||
          this.capa === "Capa couro ou tecido importado" ||
          this.capa === "Capa madeira"
        ) {
          this.hint = "Mostruário: " + m
        }
      },
      sem_img(i) {
        if (i) {
          this.img_produto = i
        }
      }
    },
    created() {
      if (this.verificaAdmin) {
        this.$store.dispatch("loadUsers");
      }
    },
    mounted() {
      this.$store.dispatch("onChanged").then((result) => {
        if (result) {
          this.$store.dispatch("loadUser", result.uid).then((res) => {
            if (res === undefined) {
                this.$router.push("/cadastro");
              }
             else {
              if (res.cancel) {
                this.$store.dispatch("logOut")
                this.$router.push("/login");
              }
                this.$store.dispatch("loadAutorizados");
                this.$store.dispatch("loadProdutos");
                this.$store.dispatch("loadPrecosCm2");
                this.$store.dispatch("loadImagens");
                if (this.$route.path !== "/") {
                  this.$router.push("/");
                }
              this.tabdef = 1 - (parseFloat(res.tabdef)/100) || 0
              if (this.tabdef === 0.99) {
                this.tabdef = 1
              }
              if (this.tabdef > 0) {
                console.log(this.tabdef)
                this.show = true;
              } else {
                this.$router.push("/analise");
              }
            }
          })
        } else {
          console.log("não logado");
          if (this.$route.path !== "/login") {
            this.$router.push("/login");
          }
        }
      });
      setTimeout(() => {
        if (this.user && this.produtos && this.precos) {
          this.tamanhos = [{
            "id": 0,
            "text": "Escolha o tipo primeiro."
          }]
          this.items_lam = [{
            "id": 0,
            "text": "Escolha o tipo primeiro."
          }]
          this.$store.dispatch('setVerificaAdmin', {uid:this.user.uid, admins:this.autorizados})
          this.img_produto = this.sem_img;
          this.show = true
        }
      }, 1000);
      this.items = this.produtos.acessorio;
    },
    data() {
      return {
        tabdef: '',
        hint: "",
        alert: false,
        msg: '',
        disabled: true,
        loading: false,
        show: false,
        hoje: new Date().toLocaleDateString("pt-BR"),
        nome: "",
        tipo: "",
        tamanho: "",
        img_produto: "",
        tamanhos: [],
        precoItems: [],
        precoCapa: "",
        precoExtra: "",
        labelCapa: "Capa",
        labelExtra: "Extras",
        laminas: 0,
        extras: 0,
        paginas: 0,
        capa: "",
        laminacao: "",
        obs: "",
        items: [],
        items_lam: [],
        item: [false, false, false, false, false, false, false, false],
        date: "",
        menu1: false,
        valor: "",
        desconto: 0
      };
    },
    methods: {
      somaExtra() {
        if(parseInt(this.extras) <= 0) {
          if(this.laminas > 0) {
            this.paginas = this.laminas * 2;
          } else {
            this.paginas = 0
          }
        }
        if(parseInt(this.extras) > 0) {
          console.log("extras:", this.extras)
          console.log("lâminas:", this.laminas)
          console.log("páginas:", this.paginas)
          let pg
          if(this.laminas <= 0) {
            pg = 0
          } else {
            pg = parseInt(this.laminas * 2)
          }
          pg = parseInt(pg) + parseInt(this.extras * 2)
          this.paginas = pg
        }
      },
      colocaBarra(c) {
        if (c.includes(" ou ")){
          c = c.replace(' ou ', '/');
        }
        return c
      },
      tiraBarra(t) {
        // c = c.replace(/pre/g, 'bla');
        if (t.includes("/")){
          t = t.replace('/', ' ou ');
        }
        return t
      },
      setImagem(img) {
        let imagem = this.sem_img;
        for (let i = 0; i < this.imagens.length; i++) {
          const el = this.imagens[i];
          if (el.nome === img) {
            imagem = el.url === "" ? this.sem_img : el.url
          }
        }
        this.img_produto = imagem;
      },
      setCapa(capa) {
        this.tamanhos = this.setTamanhoJanela(capa)
        if (
          capa === "Capa tecido ou sintético" ||
          capa === "Capa couro ou tecido importado" ||
          capa === "Capa madeira"
        ) {
          this.$store.dispatch("setShowMostruario", true)
        } else {
          this.hint = ""
        }
        if(this.tamanho) {
          this.setPrecoCapa()
        }
      },
      setPrecoCapa() {
        const tab = this.precos;
        const capa = this.capa;
        const tams = this.produtos.tamanhoPremium;
        const tam = tams.find(item => item.tamanho === this.tamanho).cm2
        let pre = tab.find(item => item.tipo === capa).valor
        if (pre.includes(",")) {
          pre = pre.replace(",", ".");
        }
        const preco = parseFloat(pre) * parseFloat(tam) / parseFloat(this.tabdef)
        this.precoCapa = parseFloat(preco).toFixed(2)
        this.labelCapa = "Capa " + this.precoCapa
        if (this.tipo === "Álbum Premium") {
          this.setPrecoExtra(tam)
        }
      },
      setPrecoExtra(tam) {
        const tab = this.precos;
        const tipo = this.tipo;
        let pre = tab.find(item => item.tipo === tipo).valor
        if (pre.includes(",")) {
          pre = pre.replace(",", ".");
        }
        const preco = parseFloat(pre) * parseFloat(tam) / parseFloat(this.tabdef)
        this.precoExtra = parseFloat(preco).toFixed(2)
        this.labelExtra = "Extras " + this.precoExtra + " cada"
      },
      setImgAcessorio(img) {
        let imagem = ""
        for (let i = 0; i < this.imagens.length; i++) {
          const el = this.imagens[i];
          if (el.nome === img) {
            imagem = el.url === "" ? this.sem_img : el.url
          }
        }
        return imagem;
      },
      setTamanhoJanela(capa) {
        const tams = this.produtos.tamanhoPremium;
        let res = []
        if (capa === "Capa janela") {
            for (let i = 0; i < tams.length; i++) {
                const el = tams[i];
                if (el.cm2 !== "450" && el.cm2 !== "800") {
                    res.push(el.tamanho)
                }
            }
            return res
        } else {
            for (let i = 0; i < tams.length; i++) {
                const el = tams[i];
                res.push(el.tamanho)
            }
            return res
        }
      },
      setTamanhoSlim() {
        const tams = this.produtos.tamanhoSlim;
        let res = []
            for (let i = 0; i < tams.length; i++) {
                const el = tams[i];
                res.push(el.tamanho)
            }
            return res
      },
      setTamanhoLamina() {
        if (this.tipo === "Álbum Premium") {
          this.tamanhos = this.setTamanhoJanela("");
          this.items_lam = this.produtos.laminasP;
        }
        if (this.tipo === "Álbum Slim") {
          this.tamanhos = this.setTamanhoSlim();
          this.items_lam = this.produtos.laminasS;
        }
      },
      tamanhoSelected(tamanho) {
        if (this.tipo === "Álbum Premium") {
          const aces = this.produtos.acessorios;
          const tab = this.precos;
          const tams = this.produtos.tamanhoPremium;
          const tam = tams.find(item => item.tamanho === tamanho).cm2
          let res = []
          for (let i = 0; i < aces.length; i++) {
            const el = aces[i];
            let pre = tab.find(item => item.tipo === el).valor
            if (pre.includes(",")) {
              pre = pre.replace(",", ".");
            }
            // Separa acessórios de valor fixo
            if (parseFloat(pre) < 10) {
              const preco = parseFloat(pre) * parseFloat(tam) / parseFloat(this.tabdef)
              res.push(parseFloat(preco).toFixed(2))
            } else {
              const preco = parseFloat(pre) / parseFloat(this.tabdef)
              res.push(parseFloat(preco).toFixed(2))
            }
          }
          this.precoItems = res
          if(this.capa) {
            this.setPrecoCapa()
          }
        }
      },
      formatDate() {
        let dia = this.date;
        let part = dia.split("-");
        this.envioDate = part[2] + "/" + part[1] + "/" + part[0];
      },
      setPaginas() {
        if (this.laminas + this.extras <= 0) {
          return;
        }
        this.paginas = this.laminas * 2;
        if (this.extras > 0) {
          let p = this.extras * 2;
          this.paginas += p;
        }
      },
      calcular() {
        if (!this.tipo || !this.tamanho || this.laminas + this.extras <= 0) {
          this.showAlert("Falta alguma informação. Verifique por favor.")
          return;
        }
        let valor = 0;
        const tipo = this.tipo
        if (tipo === "Álbum Premium") {
          if (!this.capa) {
            this.showAlert("Falta definir a capa.")
            return;
          }
          const tams = this.produtos.tamanhoPremium;
          const tam = tams.find(item => item.tamanho === this.tamanho).cm2
          const lam = parseInt(this.laminas) + parseInt(this.extras)
          const tab = this.precos;
          let pre = tab.find(item => item.tipo === tipo).valor
          if (pre.includes(",")) {
            pre = pre.replace(",", ".");
          }

          // PREÇO DOBRADO PARA TAMANHOS 35x35 e 40x40
          if(parseInt(tam) >= 2450) {
            pre = parseFloat(pre) * 2
          }
          console.log(tam, pre)
          // Fim do ajuste
          
          const preco = (parseFloat(pre) * parseFloat(tam) * parseFloat(lam)) / parseFloat(this.tabdef)

          valor += preco
          valor += this.calcLaminacao(preco)
          valor += parseFloat(this.precoCapa)
          valor += this.calcAcessorios()
          // verifica se o cliente tem desconto especial
          if (this.user.desc) {
            let d = this.user.desc
            if (d.includes(",")) {
              d = d.replace(",", ".");
            }
            const desc = parseFloat(d) / 100
            this.desconto = valor * desc
            valor -= this.desconto
            this.showAlert("Desconto de " + parseFloat(d).toFixed(2) + "% aplicado.");
          }
        }
        
        if (tipo === "Álbum Slim") {
          const tams = this.produtos.tamanhoSlim;
          const tam = tams.find(item => item.tamanho === this.tamanho).cm2
          const lam = parseInt(this.laminas) + parseInt(this.extras)
          const tab = this.precos;
          let pre = tab.find(item => item.tipo === tipo).valor
          if (pre.includes(",")) {
            pre = pre.replace(",", ".");
          }
          const preco = (parseFloat(pre) * parseFloat(tam) * parseFloat(lam)) / parseFloat(this.tabdef)
          valor += preco
          valor += this.calcLaminacao(valor)
        }
        
        this.valor = parseFloat(valor).toFixed(2)

        if (!this.verificaAdmin) {
          this.salvarCalc("calculado");
        }
        this.disabled = false;
      },
      calcAcessorios() {
        let v = 0;
        for (let i = 0; i < this.produtos.acessorios.length; i++) {
          if (this.item[i]) {
            v += parseFloat(this.precoItems[i])
          }
        }
        return parseFloat(v);
      },
      calcCapa() {
        let v = 0;
        let el = this.capa;
        const item = this.tamanho + "-" + el;
        let p3 = this.precos.acessorios[item];
        p3 = p3.replace(",", ".");
        v += parseFloat(p3);
        return parseFloat(v);
      },
      calcLaminacao(preco) {
        let lam = 0;
        if (this.laminacao === '') {
          this.laminacao = "Verniz fosco";
          this.showAlert("A laminação (Verniz fosco) foi selecionada automaticamente.");
        }
        if (this.laminacao === "Vevelt") {
          lam = parseFloat(preco) * 0.3
        }
        return lam
      },
      salvarCalc(c) {
        const obj = {
          clienteId: this.user.uid,
          clienteEmail: this.user.email,
          clientePhone: this.user.cel,
          tipo: this.tipo,
          tamanho: this.tamanho,
          laminas: this.laminas,
          extras: this.extras,
          paginas: this.paginas,
          laminacao: this.laminacao,
          obs: this.obs,
          valor: this.valor,
          data: this.dataHora(),
          save: 'Salvo'
        };
        if (this.tipo === 'Álbum Premium') {
          let acessorios = [];
          for (let i = 0; i < this.produtos.acessorios.length; i++) {
            const el = this.produtos.acessorios[i];
            if (this.item[i]) {
              acessorios.push(el);
            }
          }
          obj.acessorios = acessorios
          obj.capa = this.capa
          if (obj.capa !== 'Capa foto') {
            obj.mostruario = this.mostruario
            console.log('mostruario', this.mostruario)
          }
        }
        if (c === 'calculado') {
          obj.save = 'Só calculado'
          this.$store.dispatch("saveCalc", obj);
        } else {
          this.$store.dispatch("saveCalc", obj);
          this.showAlert("Orçamento salvo com sucesso!")
        }
      },
      btnLimpar() {
        this.tipo = "";
        this.img_produto = this.sem_img
        this.limpar();
      },
      limpar() {
        this.labelCapa = "Capa";
        this.labelExtra = "Extras";
        this.hint = "";
        this.tamanho = "";
        this.laminas = 0;
        this.paginas = 0;
        this.extras = 0;
        this.capa = "";
        this.obs = "";
        this.laminacao = "";
        this.item = [false, false, false, false, false, false, false, false, false, false];
        this.valor = "";
        this.$store.dispatch("setMostruario", null);
      },
      cancelar() {
        this.limpar();
      },
      showAlert(msg) {
        this.msg = msg
        this.alert = true;
      },
      dataHora() {
        const date = new Date().toLocaleDateString("pt-BR");
        const hora = new Date().toLocaleTimeString("pt-BR");
        return date + " " + hora;
      },
    },
  };
  </script>
  